import _isNumber from "lodash/isNumber";
import _get from "lodash/get";
import _ceil from "lodash/ceil";
import React from "react";
import { connect } from "react-redux";
import { Element } from "react-scroll";
import { titleCase } from "title-case";

import {
    getArticleAnalysisId,
    getArticleAnchorId,
    getArticleArticleId,
    getArticleBestLicense,
    getArticleBestLicenseText,
    getArticleBody,
    getArticleCityStateCountryString,
    getArticleComment,
    getArticleCopyrightNote,
    getArticleCopyrightText,
    getArticleDate,
    getArticleDescription,
    getArticleExcerpt,
    getArticleFacebookShares,
    getArticleFormattedDate,
    getArticleGroupId,
    getArticleGroupImpressions,
    getArticleId,
    getArticleIsTweet,
    getArticleLanguage,
    getArticleLanguageIsRightToLeft,
    getArticleOutletLanguage,
    getArticleOutletLanguageIsRightToLeft,
    getArticleOutletName,
    getArticleOutletUrl,
    getArticleDomId,
    getArticlePinterestShares,
    getArticlePrimaryAuthorByLine,
    getArticlePrimaryAuthorLanguage,
    getArticlePrimaryAuthorLanguageIsRightToLeft,
    getArticlePrimaryImpressions,
    getArticleSecondaryAuthorByLine,
    getArticleSecondaryAuthorLanguage,
    getArticleSecondaryAuthorLanguageIsRightToLeft,
    getArticleSecondaryCopyrightText,
    getArticleSignificance,
    getArticleSyndication,
    getArticleTermsOfUseHref,
    getArticleTitle,
    getArticleTitleRaw,
    getArticleTone,
    getArticleTotalImpressions,
    getArticleTotalShares,
    getArticleTwitterShares,
    getArticleUrl,
    getArticleGroupingItemId,
    getArticlePrimaryAuthorIsStaffWriter,
    getArticleCopy1Url,
    getArticleCopy1UrlAnchorText,
    getHaveTrackedSomething,
    getArticleGroupingItemIdMatchesInitialHash,
    getArticleImageUrl,
    getShowArticleImage,
    getArticleRawUrl,
    getArticleAssociatedArticles,
    getHavePerformedFirstScroll,
    getArticleTopSyndicatesBySharing,
    getArticleTopSyndicatesByImpressions,
} from "../../../redux/selectors/articles";
import {
    getShowFullText,
    getShowMetrics,
} from "../../../redux/selectors/newsletters";
import {
    getReactStyleArticleAuthors,
    getReactStyleArticleDates,
    getReactStyleArticleOutlets,
    getReactStyleArticleText,
    getReactStyleArticleTitles,
    getSectionBreakLinesColor,
    shouldIncludeArticleGroupImpressions,
    shouldIncludeArticlePrimaryOutletImpressions,
    shouldIncludeArticleSharesByType,
    shouldIncludeArticleSignificance,
    shouldIncludeArticleSyndication,
    shouldIncludeArticleToneIcon,
    shouldIncludeArticleToneText,
    shouldIncludeArticleTotalShares,
    shouldIncludeOutletCityState,
    shouldShowFullText,
    getAssociatedArticlesLabelText,
    getAssociatedArticlesLabelStyling,
    shouldIncludeArticleImages,
    getNewsletterUseCustomFormat,
    getReactStyleArticleMetricLabel,
    getReactStyleArticleMetricValue,
    getSyndicationLabel,
    shouldIncludeCapitalizeTitle,
    shouldIncludeListTopSyndicatesBySharing,
    shouldIncludeListTopSyndicatesByImpressions,
    getTopSyndicatesBySharingLabel,
    getTopSyndicatesByImpressionsLabel,
    getShouldShowAuthor,
} from "../../../redux/selectors/template";
import { formatNumber } from "../../../util/format";
import {
    initialArticleScroll,
    trackArticle,
} from "../../../redux/actions/articles";
import AssociatedArticle from "./AssociatedArticle";

/**
 * The main article component
 * @param props
 * @returns {*}
 * @constructor
 */
class Article extends React.Component {
    constructor(props) {
        super(props);

        const {
            haveTrackedAnArticle,
            havePerformedInitialScroll,
            articleGroupingItemIdMatchesInitialHash,
            trackArticle,
            scrollToArticle,
        } = props;

        if (articleGroupingItemIdMatchesInitialHash) {
            if (!haveTrackedAnArticle) {
                trackArticle();
            }
            if (!havePerformedInitialScroll) {
                scrollToArticle();
            }
        }
    }

    render() {
        const { isTweet } = this.props;

        if (isTweet) {
            return <Tweet props={this.props} />;
        } else {
            return (
                <TraditionalArticle
                    props={
                        this.props.isPdf
                            ? {
                                  ...this.props,
                                  copyrightText:
                                      this.props.copyrightText.replace(
                                          "&copy;",
                                          "Copyright"
                                      ),
                              }
                            : this.props
                    }
                />
            );
        }
    }
}

/**
 i.	The tweet area will have an outer border colored to match selected section break line color on AN-07b
 iv.	Tweet body displays wrapped without truncating
 v.	Byline
 e.	And the title of the Twitter article will not appear
 f.	And the excerpt of the Twitter article will not appear

 * @param props
 * @returns {*}
 * @constructor
 */
const Tweet = ({ props }) => {
    const {
        articleAnchorId,
        title,
        formattedDate,
        outletName,
        primaryAuthorByLine,
        secondaryAuthorByLine,
        outletStyle,
        authorStyle,
        dateStyle,
        shouldIncludeCityStateCountryString,
        cityStateCountryString,
        articleAnchorDomId,
        articleLanguage,
        outletLanguage,
        primaryAuthorLanguage,
        articleLanguageRtl,
        sectionBreakLinesColor,
        primaryAuthorIsStaffWriter,
        textStyle,
        copyrightText,
        groupingItemId,
        url,
        shouldShowAuthor
    } = props;

    if (title) {
        /**
         * 58. Tweets with Staff Writer as Author Do Not Display an Author on CL-04
              a. Given a user navigates to CL-04 for a Responsive newsletter
              b. And that newsletter includes content from Twitter
              c. And one of those Tweets has the Staff Writer author set
              d. When the Tweet appears
              e. Then the Author Name will not appear
              f. And the Outlet Name parentheses will be removed
              g. And the emdash will be styled to match the Outlet Name field styling
         */
        const outletCityState = shouldIncludeCityStateCountryString
            ? ` ${cityStateCountryString}`
            : "";
        const hideAuthor = primaryAuthorIsStaffWriter || !primaryAuthorByLine || !shouldShowAuthor; // If the author is missing or is a staff writer
        const includeParens = !hideAuthor;
        const authorEmDash = hideAuthor ? "" : "— ";
        const outletEmDash = hideAuthor ? "— " : "";
        const openParen = includeParens ? "(" : "";
        const closeParen = includeParens ? ")" : "";
        let authorString = hideAuthor ? "" : primaryAuthorByLine;
        if (!hideAuthor) {
            authorString += secondaryAuthorByLine
                ? ` and ${secondaryAuthorByLine}`
                : "";
        }
        return (
            <Element name={articleAnchorId}>
                <div
                    className="article tweet"
                    id={articleAnchorDomId}
                    data-grouping-item-id={groupingItemId}
                >
                    {/*{willShowFullText && <TopLicensing props={props}/>}*/}
                    <div
                        className="tweet-content p-4 mb-4"
                        style={{
                            borderColor: sectionBreakLinesColor,
                        }}
                    >
                        <div
                            className="row article-content"
                            data-grouping-item-id={groupingItemId}
                        >
                            <div className="col-11">
                                <a
                                    href={url}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="article-title-link"
                                >
                                    <div
                                        className="article-body"
                                        lang={articleLanguage}
                                        dangerouslySetInnerHTML={{
                                            __html: title,
                                        }}
                                        style={textStyle}
                                    />
                                </a>
                            </div>
                            <div className="col-1">
                                <i
                                    className="fab fa-x-twitter"
                                    title={`© ${new Date().getFullYear()} X Corp. All rights reserved.`}
                                />
                            </div>
                        </div>
                        <div>
                            <span
                                className="article-author"
                                style={authorStyle}
                                lang={primaryAuthorLanguage}
                            >
                                {authorEmDash}
                                {authorString}{" "}
                            </span>
                            <span
                                className="article-outlet"
                                style={outletStyle}
                            >
                                {openParen}
                                {outletEmDash}
                                <span lang={outletLanguage}>{outletName}</span>
                                {outletCityState}
                                {closeParen}{" "}
                            </span>
                            <span className="article-date" style={dateStyle}>
                                {formattedDate}
                            </span>
                        </div>
                    </div>
                    {/*{willShowFullText && <BottomLicensing props={props}/>}*/}

                    <ArticleMetrics props={props} />

                    <AssociatedArticles props={props} />
                </div>
            </Element>
        );
    } else {
        return null;
    }
};

const TraditionalArticle = ({ props }) => {
    const {
        articleAnchorId,
        title,
        formattedDate,
        outletName,
        primaryAuthorByLine,
        secondaryAuthorByLine,
        onArticleScrolled,
        outletStyle,
        authorStyle,
        dateStyle,
        titleStyle,
        shouldIncludeCityStateCountryString,
        cityStateCountryString,
        articleAnchorDomId,
        articleLanguage,
        outletLanguage,
        primaryAuthorLanguage,
        secondaryAuthorLanguage,
        articleLanguageRtl,
        outletLanguageRtl,
        primaryAuthorLanguageRtl,
        secondaryAuthorLanguageRtl,
        groupingItemId,
        showArticleImage,
        articleImageUrl,
        rawUrl,
        url,
        bestLicense,
        shouldIncludeImagesForArticles,
        capitalizeTitle,
        isPdf, // this is passed on from the parent (ContentPane) when it called in the context of a PDF print
        shouldShowAuthor
    } = props;

    if (title) {
        const outletCityState = shouldIncludeCityStateCountryString
            ? ` ${cityStateCountryString}`
            : "";

        let authorString;

        if (shouldShowAuthor) {
            // If we have a primary author, show it (and optional secondary author) otherwise show nothing
            authorString = primaryAuthorByLine
                ? primaryAuthorByLine +
                (secondaryAuthorByLine ? ` and ${secondaryAuthorByLine}` : "")
                : "";
        }


        const alignClass = articleLanguageRtl == "rtl" ? "text-right" : "";
        const showImage =
            shouldIncludeImagesForArticles &&
            showArticleImage &&
            articleImageUrl &&
            !isPdf;
        const finalTitle = capitalizeTitle ? titleCase(title) : title;

        const shouldUseRawUrl =
            bestLicense === "upload" &&
            rawUrl &&
            rawUrl.includes("articleviewer");

        return (
            <Element name={articleAnchorId}>
                <div
                    className="article"
                    id={articleAnchorDomId}
                    data-grouping-item-id={groupingItemId}
                >
                    <div>
                        <span className="article-outlet" style={outletStyle}>
                            <span lang={outletLanguage}>{outletName}</span>
                            {outletCityState} &#8212;
                        </span>
                        {authorString && (
                            <span
                                className="article-author"
                                style={authorStyle}
                                lang={primaryAuthorLanguage}
                            >
                                {" "}
                                {authorString},{" "}
                            </span>
                        )}
                        {!authorString && (
                            <span
                                className="article-author"
                                style={authorStyle}
                                lang={primaryAuthorLanguage}
                            >
                                {" "}
                            </span>
                        )}
                        <span className="article-date" style={dateStyle}>
                            {formattedDate}
                        </span>
                    </div>
                    <a
                        href={shouldUseRawUrl ? rawUrl : url}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="article-title-link"
                    >
                        <div
                            className={`article-title ${alignClass}`}
                            style={titleStyle}
                            lang={articleLanguage}
                            dangerouslySetInnerHTML={{ __html: finalTitle }}
                        />
                    </a>
                    {showImage && (
                        <a href={url} target="_blank" rel="noopener noreferrer">
                            <div className="article-image">
                                <img
                                    src={articleImageUrl}
                                    alt={"Article Image"}
                                    style={{
                                        width: "100%",
                                        height: "auto",
                                        objectFit: "contain",
                                    }}
                                />
                            </div>
                        </a>
                    )}
                    <ArticleMetrics props={props} />
                    <TraditionalArticleContent props={props} />
                </div>
            </Element>
        );
    } else {
        return null;
    }
};

/**
 * A component which will show top syndicates by sharing
 * @param props
 * @return {JSX.Element}
 * @constructor
 */
const TopSyndicatesBySharing = props => {
    return <div></div>;
};

/**
 * Either the article body or the article excerpt
 * @param props
 * @returns {*}
 * @constructor
 */
const TraditionalArticleContent = ({ props }) => {
    const {
        showFullText,
        body,
        excerpt,
        textStyle,
        newsletterShowFullText,
        articleLanguage,
        articleLanguageRtl,
        groupingItemId,
    } = props;

    const alignClass = articleLanguageRtl == "rtl" ? "text-right" : "";

    if (showFullText && body && newsletterShowFullText) {
        return (
            <div
                className="article-content"
                data-grouping-item-id={groupingItemId}
            >
                <TopLicensing props={props} />

                <div
                    className={`article-body mt-3 ${alignClass}`}
                    lang={articleLanguage}
                    dangerouslySetInnerHTML={{ __html: body }}
                    style={textStyle}
                />

                <BottomLicensing props={props} />

                <AssociatedArticles props={props} />
            </div>
        );
    } else {
        return (
            <div>
                <div
                    className="article-content article-excerpt mt-3"
                    dangerouslySetInnerHTML={{ __html: excerpt }}
                    style={textStyle}
                    data-grouping-item-id={groupingItemId}
                />

                <AssociatedArticles props={props} />
            </div>
        );
    }
};

/**
 * output the list of "associated articles" if any exist.
 * @param  props
 * @return {}
 */
const AssociatedArticles = ({ props }) => {
    const {
        associatedArticles,
        associatedArticlesLabelText,
        associatedArticlesLabelStyling,
    } = props;

    if (associatedArticles && associatedArticles.length) {
        return (
            <div className="mt-3">
                <span style={associatedArticlesLabelStyling}>
                    {associatedArticlesLabelText}
                </span>
                <ul className="list-inline d-inline">
                    {associatedArticles.map((giItem, index) => (
                        <AssociatedArticle
                            key={index}
                            giItem={giItem}
                            associatedArticlesLabelStyling={
                                associatedArticlesLabelStyling
                            }
                            lastItem={
                                index === associatedArticles.length - 1
                                    ? true
                                    : false
                            }
                        />
                    ))}
                </ul>
            </div>
        );
    } else {
        return null;
    }
};

/**
 * The top licensing for this article
 * @param props
 * @constructor
 */
const TopLicensing = ({ props }) => {
    const {
        bestLicenseText,
        copyrightNote,
        secondaryCopyrightText,
        textStyle,
    } = props;
    return (
        <div className="top-licensing mt-3" style={textStyle}>
            {bestLicenseText && (
                <div
                    dangerouslySetInnerHTML={{
                        __html: `Via ${bestLicenseText}`,
                    }}
                ></div>
            )}
            {copyrightNote && (
                <div
                    dangerouslySetInnerHTML={{
                        __html: `Licensed Text:  ${copyrightNote}`,
                    }}
                ></div>
            )}
            {secondaryCopyrightText && (
                <div
                    dangerouslySetInnerHTML={{ __html: secondaryCopyrightText }}
                ></div>
            )}
        </div>
    );
};

/**
 * The bottom licensing for this article
 * @param props
 * @constructor
 */
const BottomLicensing = ({ props }) => {
    const {
        copyrightText,
        termsOfUseHref,
        copy1AnchorText,
        copy1Url,
        textStyle,
    } = props;
    let copyrightContent = copyrightText;
    if (copy1AnchorText && copy1Url) {
        copyrightContent += ` <a href="${copy1Url}" target="_blank" rel="noopener noreferrer">${copy1AnchorText}</a>`;
    }
    return copyrightContent || termsOfUseHref ? (
        <div className="bottom-licensing mt-3" style={textStyle}>
            {copyrightContent && (
                <div
                    dangerouslySetInnerHTML={{ __html: copyrightContent }}
                ></div>
            )}
            {termsOfUseHref && (
                <a
                    href={termsOfUseHref}
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    Terms of Use
                </a>
            )}
        </div>
    ) : null;
};

/**
 * The article metrics
 * @param props
 * @returns {*}
 * @constructor
 */
const ArticleMetrics = ({ props }) => {
    const {
        showMetrics,
        primaryImpressions,
        groupImpressions,
        significance,
        syndication,
        syndicationLabel,
        tone,
        facebookShares,
        pinterestShares,
        totalShares,
        twitterShares,
        hasSharesByType,
        hasTotalShares,
        hasSyndication,
        hasGroupImpressions,
        hasPrimaryOutletImpressions,
        hasSignificance,
        hasToneText,
        hasToneIcon,
        isTweet,
        metricValueStyleObject,
        metricLabelStyleObject,
        customNewsletterFormat,
        includeTopSyndicatesBySharing,
        includeTopSyndicatesByImpressions,
        topSyndicatesBySharing,
        topSyndicatesBySharingLabel,
        topSyndicatesByImpressions,
        topSyndicatesByImpressionsLabel,
    } = props;

    if (showMetrics) {
        const metrics = [];
        const includeToneIcon = hasToneIcon && _isNumber(tone);
        const includeToneText = hasToneText && _isNumber(tone);
        // No impressions or syndicates for tweets
        const includeGroupImpressions =
            !isTweet &&
            hasGroupImpressions &&
            _isNumber(groupImpressions) &&
            groupImpressions > 0;
        const includePrimaryImpressions =
            !isTweet &&
            hasPrimaryOutletImpressions &&
            _isNumber(primaryImpressions) &&
            primaryImpressions > 0;
        const includeSyndication =
            !isTweet &&
            hasSyndication &&
            _isNumber(syndication) &&
            syndication > 0;

        const includeTotalShares =
            hasTotalShares && _isNumber(totalShares) && totalShares > 0;
        const includeFacebookShares =
            hasSharesByType && _isNumber(facebookShares) && facebookShares > 0;
        const includeTwitterShares =
            hasSharesByType && _isNumber(twitterShares) && twitterShares > 0;
        const includePinterestShares =
            hasSharesByType &&
            _isNumber(pinterestShares) &&
            pinterestShares > 0;
        const includeSignificance = hasSignificance && _isNumber(significance);
        const labelStyleObj = customNewsletterFormat
            ? metricLabelStyleObject
            : {};
        const valueStyleObj = customNewsletterFormat
            ? metricValueStyleObject
            : {};

        const toneMap = {
            "-2": {
                icon: "— —",
                text: "Very Negative",
                className: "negative",
            },
            "-1": {
                icon: "—",
                text: "Negative",
                className: "negative",
            },
            0: {
                icon: "o",
                text: "Neutral",
                className: "neutral",
            },
            1: {
                icon: "+",
                text: "Positive",
                className: "positive",
            },
            2: {
                icon: "+ +",
                text: "Very Positive",
                className: "positive",
            },
        };
        if (includeToneIcon) {
            metrics.push(
                <div className="metric col-12 col-md-4" key="toneIcon">
                    <span style={labelStyleObj} className="metric-label col">
                        Tone:
                    </span>
                    <span
                        style={valueStyleObj}
                        className={`metric-value col text-right icon-size ${_get(
                            toneMap[tone],
                            "className"
                        )}`}
                    >
                        {_get(toneMap[tone], "icon")}
                    </span>
                </div>
            );
        }
        if (includeToneText) {
            metrics.push(
                <div className="metric col-12 col-md-4" key="toneText">
                    <span style={labelStyleObj} className="metric-label col">
                        Tone:
                    </span>
                    <span
                        style={valueStyleObj}
                        className={`metric-value col text-right ${_get(
                            toneMap[tone],
                            "className"
                        )}`}
                    >
                        {_get(toneMap[tone], "text")}
                    </span>
                </div>
            );
        }
        if (includeGroupImpressions) {
            metrics.push(
                <div className="metric col-12 col-md-4" key="groupImpressions">
                    <span style={labelStyleObj} className="metric-label col">
                        Group Impressions:
                    </span>
                    <span
                        style={valueStyleObj}
                        className="metric-value col text-right"
                    >
                        {formatNumber(groupImpressions)}
                    </span>
                </div>
            );
        }
        if (includePrimaryImpressions) {
            metrics.push(
                <div
                    className="metric col-12 col-md-4"
                    key="primaryImpressions"
                >
                    <span style={labelStyleObj} className="metric-label col">
                        Primary Impressions:
                    </span>
                    <span
                        style={valueStyleObj}
                        className="metric-value col text-right"
                    >
                        {formatNumber(primaryImpressions)}
                    </span>
                </div>
            );
        }
        if (includeTotalShares) {
            metrics.push(
                <div className="metric col-12 col-md-4" key="totalShares">
                    <span style={labelStyleObj} className="metric-label col">
                        Total Social Interactions:
                    </span>
                    <span
                        style={valueStyleObj}
                        className="metric-value col text-right"
                    >
                        {formatNumber(totalShares)}
                    </span>
                </div>
            );
        }
        if (includeFacebookShares) {
            metrics.push(
                <div className="metric col-12 col-md-4" key="facebookShares">
                    <span style={labelStyleObj} className="metric-label col">
                        Facebook:
                    </span>
                    <span
                        style={valueStyleObj}
                        className="metric-value col text-right"
                    >
                        {formatNumber(facebookShares)}
                    </span>
                </div>
            );
        }
        if (includeTwitterShares) {
            metrics.push(
                <div className="metric col-12 col-md-4" key="twitterShares">
                    <span style={labelStyleObj} className="metric-label col">
                        X.com:
                    </span>
                    <span
                        style={valueStyleObj}
                        className="metric-value col text-right"
                    >
                        {formatNumber(twitterShares)}
                    </span>
                </div>
            );
        }
        if (includePinterestShares) {
            metrics.push(
                <div className="metric col-12 col-md-4" key="pinterestShares">
                    <span style={labelStyleObj} className="metric-label col">
                        Pinterest:
                    </span>
                    <span
                        style={valueStyleObj}
                        className="metric-value col text-right"
                    >
                        {formatNumber(pinterestShares)}
                    </span>
                </div>
            );
        }

        if (includeSyndication) {
            metrics.push(
                <div className="metric col-12 col-md-4" key="syndication">
                    <span style={labelStyleObj} className="metric-label col">
                        {syndicationLabel + ":"}
                    </span>
                    <span
                        style={valueStyleObj}
                        className="metric-value col text-right"
                    >
                        {formatNumber(syndication)}
                    </span>
                </div>
            );
        }
        if (includeSignificance) {
            const significanceTextMap = {
                0: "Low",
                1: "Medium",
                2: "High",
            };
            metrics.push(
                <div className="metric col-12 col-md-4" key="significance">
                    <span style={labelStyleObj} className="metric-label col">
                        Significance:
                    </span>
                    <span
                        style={valueStyleObj}
                        className="metric-value col text-right"
                    >
                        {significanceTextMap[significance]}
                    </span>
                </div>
            );
        }
        if (includeTopSyndicatesBySharing && topSyndicatesBySharing) {
            metrics.push(
                <div className="metric col-12 pt-2" key="socialReach">
                    <span style={labelStyleObj} className="metric-label col">
                        {topSyndicatesBySharingLabel + ":"}
                    </span>
                    <span
                        style={valueStyleObj}
                        className="metric-value col text-right"
                    >
                        {topSyndicatesBySharing}
                    </span>
                </div>
            );
        }
        if (includeTopSyndicatesByImpressions && topSyndicatesByImpressions) {
            metrics.push(
                <div className="metric col-12 pt-2" key="socialReach">
                    <span style={labelStyleObj} className="metric-label col">
                        {topSyndicatesByImpressionsLabel + ":"}
                    </span>
                    <span
                        style={valueStyleObj}
                        className="metric-value col text-right"
                    >
                        {topSyndicatesByImpressions}
                    </span>
                </div>
            );
        }
        const numTriads = _ceil(metrics.length / 3);
        const triads = [];
        let metricIndex = 0;
        for (let triadIndex = 0; triadIndex < numTriads; triadIndex++) {
            triads.push(
                <div
                    className="row pb-0 pb-md-2 align-items-baseline"
                    key={triadIndex}
                >
                    {metrics[metricIndex] && metrics[metricIndex]}
                    {metrics[metricIndex + 1] && metrics[metricIndex + 1]}
                    {metrics[metricIndex + 2] && metrics[metricIndex + 2]}
                </div>
            );
            metricIndex += 3;
        }

        return <div className="article-metrics">{triads}</div>;
    } else {
        return null;
    }
};

/**
 * mapStateToProps returns the parts of the state that will be available as props
 * @param state
 * @returns {{navigation: *}}
 */
const mapStateToProps = (state, ownProps) => {
    const { id } = ownProps;

    return {
        showFullText: getShowFullText(state),
        showMetrics: getShowMetrics(state),
        analysisId: getArticleAnalysisId(state, id),
        articleAnchorId: getArticleAnchorId(state, id),
        articleId: getArticleArticleId(state, id),
        bestLicense: getArticleBestLicense(state, id),
        body: getArticleBody(state, id),
        cityStateCountryString: getArticleCityStateCountryString(state, id),
        shouldIncludeCityStateCountryString:
            shouldIncludeOutletCityState(state),
        shouldIncludeImagesForArticles: shouldIncludeArticleImages(state),
        comment: getArticleComment(state, id),
        date: getArticleDate(state, id),
        description: getArticleDescription(state, id),
        excerpt: getArticleExcerpt(state, id),
        formattedDate: getArticleFormattedDate(state, id),
        groupId: getArticleGroupId(state, id),
        groupImpressions: getArticleGroupImpressions(state, id),
        id: getArticleId(state, id),
        outletName: getArticleOutletName(state, id),
        outletUrl: getArticleOutletUrl(state, id),
        primaryAuthorByLine: getArticlePrimaryAuthorByLine(state, id),
        primaryImpressions: getArticlePrimaryImpressions(state, id),
        secondaryAuthorByLine: getArticleSecondaryAuthorByLine(state, id),
        significance: getArticleSignificance(state, id),
        syndication: getArticleSyndication(state, id),
        syndicationLabel: getSyndicationLabel(state),
        title: getArticleTitle(state, id),
        titleRaw: getArticleTitleRaw(state, id),
        tone: getArticleTone(state, id),
        url: getArticleUrl(state, id),
        rawUrl: getArticleRawUrl(state, id),
        articleImageUrl: getArticleImageUrl(state, id),
        showArticleImage: getShowArticleImage(state, id),
        outletStyle: getReactStyleArticleOutlets(state),
        authorStyle: getReactStyleArticleAuthors(state),
        dateStyle: getReactStyleArticleDates(state),
        titleStyle: getReactStyleArticleTitles(state),
        textStyle: getReactStyleArticleText(state),
        bestLicenseText: getArticleBestLicenseText(state, id),
        copyrightNote: getArticleCopyrightNote(state, id),
        secondaryCopyrightText: getArticleSecondaryCopyrightText(state, id),
        termsOfUseHref: getArticleTermsOfUseHref(state, id),
        copy1Url: getArticleCopy1Url(state, id),
        copy1AnchorText: getArticleCopy1UrlAnchorText(state, id),
        copyrightText: getArticleCopyrightText(state, id),
        newsletterShowFullText: shouldShowFullText(state),
        hasToneIcon: shouldIncludeArticleToneIcon(state),
        hasToneText: shouldIncludeArticleToneText(state),
        hasSignificance: shouldIncludeArticleSignificance(state),
        hasPrimaryOutletImpressions:
            shouldIncludeArticlePrimaryOutletImpressions(state),
        hasGroupImpressions: shouldIncludeArticleGroupImpressions(state),
        hasSyndication: shouldIncludeArticleSyndication(state),
        hasTotalShares: shouldIncludeArticleTotalShares(state),
        hasSharesByType: shouldIncludeArticleSharesByType(state),
        facebookShares: getArticleFacebookShares(state, id),
        pinterestShares: getArticlePinterestShares(state, id),
        totalImpressions: getArticleTotalImpressions(state, id),
        totalShares: getArticleTotalShares(state, id),
        twitterShares: getArticleTwitterShares(state, id),
        articleLanguage: getArticleLanguage(state, id),
        outletLanguage: getArticleOutletLanguage(state, id),
        primaryAuthorIsStaffWriter: getArticlePrimaryAuthorIsStaffWriter(
            state,
            id
        ),
        primaryAuthorLanguage: getArticlePrimaryAuthorLanguage(state, id),
        secondaryAuthorLanguage: getArticleSecondaryAuthorLanguage(state, id),
        articleLanguageRtl: getArticleLanguageIsRightToLeft(state, id),
        outletLanguageRtl: getArticleOutletLanguageIsRightToLeft(state, id),
        primaryAuthorLanguageRtl: getArticlePrimaryAuthorLanguageIsRightToLeft(
            state,
            id
        ),
        secondaryAuthorLanguageRtl:
            getArticleSecondaryAuthorLanguageIsRightToLeft(state, id),
        isTweet: getArticleIsTweet(state, id),
        sectionBreakLinesColor: getSectionBreakLinesColor(state),
        getArticleDomId: getArticleDomId(state, id),
        groupingItemId: getArticleGroupingItemId(state, id),
        haveTrackedAnArticle: getHaveTrackedSomething(state),
        havePerformedInitialScroll: getHavePerformedFirstScroll(state),
        articleGroupingItemIdMatchesInitialHash:
            getArticleGroupingItemIdMatchesInitialHash(state, id),
        associatedArticles: getArticleAssociatedArticles(state, id),
        associatedArticlesLabelText: getAssociatedArticlesLabelText(state),
        associatedArticlesLabelStyling:
            getAssociatedArticlesLabelStyling(state),
        customNewsletterFormat: getNewsletterUseCustomFormat(state),
        metricLabelStyleObject: getReactStyleArticleMetricLabel(state),
        metricValueStyleObject: getReactStyleArticleMetricValue(state),
        capitalizeTitle: shouldIncludeCapitalizeTitle(state),
        includeTopSyndicatesBySharing:
            shouldIncludeListTopSyndicatesBySharing(state),
        includeTopSyndicatesByImpressions:
            shouldIncludeListTopSyndicatesByImpressions(state),
        topSyndicatesBySharing: getArticleTopSyndicatesBySharing(state, id),
        topSyndicatesByImpressions: getArticleTopSyndicatesByImpressions(
            state,
            id
        ),
        topSyndicatesBySharingLabel: getTopSyndicatesBySharingLabel(state),
        topSyndicatesByImpressionsLabel:
            getTopSyndicatesByImpressionsLabel(state),
        shouldShowAuthor: getShouldShowAuthor(state)
    };
};

/**
 * mapDispatchToProps exposes the actions we want to call as props
 * @param state
 * @returns {{navigation: *}}
 */
const mapDispatchToProps = (dispatch, ownProps) => {
    const { id, sectionId } = ownProps;

    return {
        trackArticle: () => {
            dispatch(trackArticle(id));
        },
        scrollToArticle: () => {
            dispatch(initialArticleScroll(id));
        },
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(Article);
